import { render, staticRenderFns } from "./StockDocumentFilesPanel.vue?vue&type=template&id=f4495526&scoped=true"
import script from "./StockDocumentFilesPanel.vue?vue&type=script&lang=js"
export * from "./StockDocumentFilesPanel.vue?vue&type=script&lang=js"
import style0 from "./StockDocumentFilesPanel.vue?vue&type=style&index=0&id=f4495526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4495526",
  null
  
)

export default component.exports